import { H5, H6 } from "@sellar-io/components";
export type OrderInvoicesSentToProps = {
  emailAddresses: string[];
};

export const OrderInvoicesSentTo = (
  props: OrderInvoicesSentToProps,
): React.ReactElement => {
  return (
    <div className="flex flex-col gap-2">
      <H5>Sent to</H5>
      <div>
        <H6 className={"select-text"}>{props.emailAddresses.join(", ")}</H6>
      </div>
    </div>
  );
};
